import React, { useState, useLayoutEffect } from "react";
import TopMenu from "../LargeViewPorts/Menu/TopMenu";
import Fade from "react-reveal/Fade";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import InsideMenu from "../LargeViewPorts/Menu/InsideMenu";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import { withRouter } from "react-router";
function useWindowSize() {
  const [size, setSize] = useState(0);
  useLayoutEffect(() => {
    function updateSize() {
      setSize(window.innerWidth);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
}
function MenuList(props) {
  var task = "";
  const width = useWindowSize();
  var obj = { width };
  var myJSON = JSON.stringify(obj);
  let k = myJSON.substr(9, 11);
  let x = parseFloat(k);
  if (x > 740) {
    task = props.history.push("/");
  } else {
    task = <ChildF />;
  }
  return <>{task}</>;
}

function ChildF() {
  const [show, setShow] = useState("none");
  return (
    <div style={{ overflowY: "hidden" }}>
      <TopMenu />
      <div className="menu-list">
        <div onClick={() => setShow("MAKE UP")} className="menu-list-item">
          <span>Make up</span>
          <NavigateNextIcon style={{ marginRight: "40px" }} />
        </div>

        <div onClick={() => setShow("Hair")} className="menu-list-item">
          <span>Hair</span>
          <NavigateNextIcon style={{ marginRight: "40px" }} />
        </div>

        <div
          onClick={() => setShow("BEAUTY MAGAZINE")}
          className="menu-list-item"
        >
          <span>Beauty Magazine</span>
          <NavigateNextIcon style={{ marginRight: "40px" }} />
        </div>
        <div onClick={() => setShow("Other Items")} className="menu-list-item">
          <span>Other Items</span>
          <NavigateNextIcon style={{ marginRight: "40px" }} />
        </div>
      </div>
      <Fade right duration={500}>
        <div
          style={{
            width: "100%",
            height: "100vh",
            backgroundColor: "white",
            position: "fixed",
            overflowY: "scroll",
            zIndex: "10",
            top: "93px",
            overflowX: "hidden",
            display: show === "none" ? "none" : "block"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              fontWeight: "bold",
              width: "100%",
              backgroundColor: "pink",
              padding: "20px",
              overflowX: "hidden"
            }}
            onClick={() => setShow("none")}
          >
            <NavigateBeforeIcon
              style={{ marginRight: "20px", marginTop: "3px" }}
            />
            <span>{show}</span>
          </div>
          <InsideMenu mode={show} />
        </div>
      </Fade>
    </div>
  );
}

export default withRouter(MenuList);
